export const uuidV4 = () => crypto.randomUUID();
export const validateUUID = (uuid: unknown): boolean => {
  // REGEX is from UUID Package https://github.com/uuidjs/uuid/blob/main/src/regex.ts
  const REGEX =
    /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;
  return typeof uuid === 'string' && REGEX.test(uuid);
};
